import './utils/tracer';
import { Command } from 'commander';
import commands from './commands';
import packageJson from '../package.json';

const { version } = packageJson;

const program = new Command();

program.name('moose').description('CLI tool for Moose').version(version);

Object.values(commands).forEach((command) => {
  program.addCommand(command);
});

program.parse();
